import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../utils/axiosInstance";

export const fetchOverallBookWiseReport = createAsyncThunk(
  "summary/fetchOverallBookwiseReport",
  async () => {
    const response = await axiosInstance.get("api/summary/getall");
    return response.data;
  }
);

export const fetchAllYearwiseBookwiseReport = createAsyncThunk(
  "summary/fetchAllYearwiseBookwiseReport",
  async () => {
    try {
      const response = await axiosInstance.get(
        "api/summary/all-yearwise-bookwise"
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching bookwise record yearwise:", error);
      throw error;
    }
  }
);

export const fetchYearlyBookwiseReport = createAsyncThunk(
  "summary/fetchYearlyBookwiseReport",
  async ({ fromdate, todate }) => {
    try {
      const fromDateformat = new Date(fromdate).toISOString(); 
      const toDateformat = new Date(todate).toISOString();
      const response = await axiosInstance.get(
        "api/summary/yearwise-bookwise",
        {
          params: { fromDate: fromDateformat, toDate: toDateformat },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);
export const fetchYearwiseBookwiseSummary = createAsyncThunk(
  "summary/fetchYearwiseBookwiseSummary",
  async ({ fromBookNo, toBookNo, year }) => {
    try {
      const params = { fromBookNo, toBookNo };
      // year select pannirundha rendu (fromYear/toYear) same value —
      // Format 2 (single year filter). Illana Format 1 (all years, grouped).
      if (year) {
        params.fromYear = year;
        params.toYear = year;
      }
      const response = await axiosInstance.get(
        "api/summary/yearwise-bookwise",
        { params }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchBookRangeByDate = createAsyncThunk(
  "summary/fetchBookRangeByDate",

  async ({ fromdate, todate }) => {
    try {
      const fromDateformat = new Date(fromdate).toISOString(); 
      const toDateformat = new Date(todate).toISOString();
      const response = await axiosInstance.get("api/summary/startend-bookno", {
        params: { fromDate: fromDateformat, toDate: toDateformat },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);
export const fetchReceiptYearRange = createAsyncThunk(
  "summary/fetchReceiptYearRange",
  async () => {
    const response = await axiosInstance.get("api/summary/year-range");
    return response.data; // { minYear, maxYear }
  }
);

const summaryReportSlice = createSlice({
  name: "summaryReport",
  initialState: {
    bookwiseAll: [],
    bookwiseYearly: [],
    bookRange: [],
    loading: false,
    error: null,
    page: 1,
    limit: 10,
     minYear: null,   // NEW
    maxYear: null,
  },
  reducers: {
    setPage(state, action) {
      state.page = action.payload;
    },
    setLimit(state, action) {
      state.limit = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOverallBookWiseReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOverallBookWiseReport.fulfilled, (state, action) => {
        state.loading = true;
        state.error = null;
        state.summaryBookWiseAllReport = action.payload;
      })
      .addCase(fetchOverallBookWiseReport.rejected, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchYearlyBookwiseReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchYearlyBookwiseReport.fulfilled, (state, action) => {
        state.loading = true;
        state.summaryBookWiserYearlyReport = action.payload;
      })
      .addCase(fetchYearlyBookwiseReport.rejected, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchYearwiseBookwiseSummary.pending, (state) => {
  state.loading = true;
  state.error = null;
})
.addCase(fetchYearwiseBookwiseSummary.fulfilled, (state) => {
  state.loading = false;
  state.error = null;
})
.addCase(fetchReceiptYearRange.fulfilled, (state, action) => {
  state.minYear = action.payload.minYear;
  state.maxYear = action.payload.maxYear;
})
.addCase(fetchYearwiseBookwiseSummary.rejected, (state, action) => {
  state.loading = false;
  state.error = action.error?.message;
})
      .addCase(fetchAllYearwiseBookwiseReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllYearwiseBookwiseReport.fulfilled, (state, action) => {
        state.loading = true;
        state.error = null;
        state.bookwiseYearly = action.payload;
      })
      .addCase(fetchAllYearwiseBookwiseReport.rejected, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchBookRangeByDate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBookRangeByDate.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.bookRange = action.payload;
      })
      .addCase(fetchBookRangeByDate.rejected, (state, action) => {
        state.loading = false;
        state.error = null;
      });
  },
});

export const { setPage, setLimit } = summaryReportSlice.actions;
export default summaryReportSlice.reducer;
